module.exports = __webpack_public_path__ + "static/img/P4.9baed0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qdzy/P4.png
// module id = 7CQ8
// module chunks = 0